<template>
  <article class="pftm">
    <div class="pftm__flex-row" v-if="!storeB2B">
      <div class="pftm__flex-row pftm__review-row pftm__space-between">
        <span class="pftm__review-stars-container" >
            <div @click="redirect()" v-if="context === 'quickshop'">
              <product-reviews-badge :product="product" :settings="settings"></product-reviews-badge>
            </div>
          <product-reviews-badge :product="product" :settings="settings" v-else></product-reviews-badge>
        </span>
      </div>
    </div>
    <div class="pftm__vendor">
      <h2 class="pftm__vendor pftm__vendor-header ">
        <a class="pftm__vendor-link" :href="productVendorURL">
          {{product.vendor}}
        </a>
      </h2>
    </div>
    <div class="pftm__align-top">
      <div class="pftm__title-container">
        <h1 class="pftm__product-title">{{ product.title }}</h1>
      </div>
      <div class="pftm__price-container" v-if="!customFields.hide_price">
        <span class="pftm__price pdp-price" v-if="variant" :class="{'color-util-sale pftm--price-onsale': prices.price < prices.compare_at_price }">
          {{ prices.price | moneyWithoutDecimals }} 
        </span>
        <s class="pftm__price-compare pdp-price-compare" v-if="variant && prices.price < prices.compare_at_price">
          {{ prices.compare_at_price | moneyWithoutDecimals }}
        </s>
        <span class="pftm__custom_text" v-html="customFields.pdp_price_custom_text"></span> 
        
      </div>
    </div>
    <div class="pftm__product-skin-types" v-if="context === 'quickshop'">
        <span class="label-skin-type">Skin Type: </span><span class="skin-types-content">{{ skinTypes() }}</span>
      </div>
    <div class="pftm__afterpay" v-if="context === 'PDP' && !storeB2B">
      <afterpay-placement data-locale="en_US"  data-currency="USD" :data-amount="prices.price | moneyWithoutDecimals" data-logo-type="lockup" data-modal-link-style="circled-question-icon" data-modal-theme="white" data-size="xs"></afterpay-placement>
    </div>
    <div class="body-md client-generated pftm__summary" v-if="customFields.d2_short_description && $mq !== 'mobile' && !isGiftCard">
      <span v-html="customFields.d2_short_description"></span>
      <!-- <a href="#" v-if="context === 'PDP'" class="more-details-cta" @click.prevent="openAccordion" >More Details </a> -->
      <!-- Is this for Desktop? WHen I hide it, it'll disappear on desktop -->
      <a :href="product.url" v-if="context=='quickshop'" class="more-details-cta" >More Details</a>
    </div>
  </article>
</template>

<script>
import { badgeList, assetUrl } from '@/scripts/helpers/util'
import { scrollToId } from '@/scripts/helpers/scroll'
import VLink from '@/scripts/components/buttons/VLink.vue'
import Icon from '@/scripts/components/basic/Icon.vue'
import ProductReviewsBadge from '@/scripts/components/product/ProductReviewsBadge.vue'
import lowercase from 'lodash/lowerCase'

export default {
  name: 'ProductFormTopMobile',
  props: {
    collection: Object,
    product: Object,
    customFields: {
      type: Object,
      default: {}
    },
    variant: Object,
    settings: Object,
    prices: Object,
    context: {
      type: String,
      default: "PDP"
    }
  },
  model: {
    prop: 'variant'
  },
  components: {
    VLink,
    Icon,
    ProductReviewsBadge
  },
  methods: {
    lowercase,
    assetUrl,
    scrollToId,
    openAccordion () {
      return scrollToId(null, '#product-details-accordion')
    },
    skinTypes () {
        if(this.customFields &&  Array.isArray(this.customFields.skin_type)){
          return this.customFields.skin_type.map(skin_type=>
            skin_type.skin_type_options!=='' && skin_type.skin_type_options
            ).filter(key=>key!=false).join(", ")
        }else{
          return '';
        }
      },
    redirect () {
      window.location.href = `${this.product.url}?scroll=review`;
    }
  },
  computed: {
    storeB2B () {
      return window.bvaccel.b2b == true && window.bvaccel.b2b_no_company_assigned == false ;
    },
    productVendorURL () {
      return `/collections/${this.product.vendor.toLowerCase().replaceAll(/\s+/g, '-')}`;
    },
    subtitle () {
      const { subtitlePretext, showSKU } = this.settings
      const cfVendor = this.variant && this.variant.cf_vendor ? this.variant.cf_vendor : this.customFields.product_vendor
      const vendorText = showSKU ? this.variant.sku : cfVendor

      if (subtitlePretext && vendorText) { return subtitlePretext + ' ' + vendorText } else if (vendorText) { return vendorText }
      return ''
    },
    onSale () {
      return this.variant && this.variant.price < this.variant.compare_at_price
    },
    badges () {
      return badgeList(this.product, this.variant, this.onSale)
    },
    staticProductTitle() {
      const t = this.product.title;
      return t.substr(0, t.lastIndexOf('-'));
    },
    isGiftCard() {
      return this.product.type.toUpperCase().includes("GIFT CARDS");
    },
  }
}
</script>

<style lang="scss" scoped>
  .pftm {
    padding-top: 12px;
    padding-bottom: 12px;

    > * + * {
      margin-top: 4px;
    }

    &__summary {
      padding: 8px 0 12px;
      border-bottom: 1px solid $color-black-500;
      .more-details-cta {
        padding-left: 5px;
      }
    }
    &__custom_text{
      font-family: $font-family-primary;
      font-size: rem(16);
      padding-left: 4px;
      @include mobile-only {
        font-size: rem(16);
      }
    }

    &__price {
      font-family: $font-family-primary;
      font-size: rem(16);
      font-weight: 900;
      @include mobile-only {
        font-size: rem(16);
      }
    }

    &__price.pftm--price-onsale {
      font-size: rem(18);
    }

    .pftm__vendor-link {
      color: inherit;
      text-decoration: none;
    }

    &__price-compare {
      color: $color-black;
      font-size: rem(12);
      font-family: $font-family-primary;
      line-height: rem(15);
      display: inline;

      @include tablet-up {
        display: inline;
        padding-top: 8px;
        font-size: rem(14);
        line-height: rem(15);
      }
    }

    &__space-between {
      justify-content: space-between;
    }

    &__vendor {
      font-size: rem(12);
      line-height: rem(16);
      margin-bottom: 6px;
    }
    &__vendor-header{
      text-transform: inherit;
    }

    &__product-title {
      font-size: rem(32);
      line-height: rem(42);
      letter-spacing: -0.1px;
      padding-right: 12px;
      text-transform: initial;
      @include mobile-tablet {
        font-size: rem(22);
        line-height: 25px;
      }
    }

    &__product-skin-types {
      font-size: rem(15);
      line-height: rem(20);
      margin-bottom: 0px;
      margin-top: 19px;
      color: $color-green-slate-200;

      span.label-skin-type {
        font-weight: 600;
      }
      span.skin-types-content {
        font-weight: $font-weight-global;
      }

    }

    &__flex-row {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      position: relative;
      width: 100%;
    }

    &__title-container {
      flex: 1 1 75%;
    }

    &__price-container {
      flex: 1 1 25%;
      text-align: right;

      @include tablet-up {
        flex-direction: row;
        text-align: left;
        padding-top: 8px;
      }
    }

    .link {
      text-decoration: underline;
    }

    .link::before,
    .link__content::before {
      display: none;
    }

    ::v-deep .write-review-btn-hidden {
      padding-left: 5px;
      font-size: rem(11);
      position: relative;
      top: -1px;
    }

    ::v-deep .text-m {
      font-size: rem(10);
      text-decoration: underline !important;
      margin-left: 5px;
    }

    ::v-deep .yotpo-icon {
      font-size: rem(13) !important;
      padding-right: 1px;
      &:last-child {
        padding-right: 0;
      }
    }

    &__review-stars-container {
      @include mobile-only {
        right: 0;
        position: absolute;
        top: 10px;
      }
      height: 20px; // static height so content below doesnt jump when stars load
      margin-bottom: 0px;
    }

    .badge {
      position: relative;
      top: unset;
      left: unset;
      pointer-events: none;
      float: right;
      margin-left: 8px;
      font-size: rem(12);
      padding: 2px 0;
    }

    @include tablet-up {
      display: none;
      padding-bottom: 24px - 16px;
      margin-bottom: 0;
      padding-top: 0;
    }

    &__align-top {
      @include mobile-only {
        padding: 9px 0;
        display: flex;
        flex-direction: column;
        border-bottom: 1px solid $color-black-500;
      }
      align-items: flex-start !important;
    }

    p.afterpay-paragraph {
      font-size: 12px;
    }

  }

</style>
